import { User } from "../api/main/models/User";
import { getComplianceAreaUrl } from "./getComplianceAreaUrl";

/**
 * Returns a link to the compliance area showing the requirement provided.
 */
export function getComplianceRequirementUrl(requirementOriginKey: string, requirementAreaId: string, user: User | undefined | null, schoolId: string | undefined | null): string {
    return `${getComplianceAreaUrl(requirementAreaId, user, schoolId)}/?requirement=${encodeURIComponent(requirementOriginKey ?? '')}`;
}